<template>
  <div class="historycomment-list">
    <Form :model="formItem"
          ref="formItem"
          :inline="true"
          action="javascript:void(0)">
      <FormItem>
        <Input v-model="formItem.key"
               placeholder="输入头条标题"
               style="width:200px"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary"
                @click="renderTable('formItem')">筛选</Button>
      </FormItem>
    </Form>
    <Table border
           :columns="columns"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer width="50"
            v-model="modal1"
            title="订单详情"
            :mask-closable="false"
            @on-cancel="modal1 = false">
      <Row>
        <Col :xs="24"
             :md="24">
        <Table border
               stripe
               :columns="columsgood"
               :data="datagood"></Table>
        </Col>
      </Row>
    </Drawer>
  </div>
</template>

<script>
export default {
  name: "historycomment-list",
  data () {
    return {
      title: "",
      dataloading: true,
      formItem: {},
      modal1: false,
      //订单详情
      columsgood: [
        {
          title: "回复内容",
          key: "comment",
          width: 200,
          align: "center",
        },
        {
          title: "用户名",
          minWidth: 120,
          key: "username",
          align: "center",
        },
        {
          title: "回复时间",
          align: "center",
          key: "created_at",
          width: 250,
        },
        {
          title: "状态",
          width: 150,
          key: "status",
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.status == "1" ? "下架" : "上架")
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display: params.row.status == "1" ? "inline-block" : "none"
                  },
                  on: {
                    click: () => {
                      this.reviewreply(params.row.id, 0);
                    }
                  }
                },
                "上架"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display: params.row.status == "0" ? "inline-block" : "none"
                  },
                  on: {
                    click: () => {
                      this.reviewreply(params.row.id, 1);
                    }
                  }
                },
                "下架"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.removereply(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      datagood: [],
      pages: {
        current: 1,
        total: 0,
        size: 20
      },
      columns: [
        {
          title: "Id",
          key: "id",
          width: 80
        },
        {
          title: "头条标题",
          minWidth: 300,
          key: "title"
        },
        {
          title: "评论内容",
          minWidth: 300,
          key: "comment"
        },
        {
          title: "用户名",
          minWidth: 200,
          key: "username"
        },
        {
          title: "发布时间",
          minWidth: 200,
          key: "created_at"
        },
        {
          title: "状态",
          width: 150,
          key: "status",
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.status == "1" ? "下架" : "上架")
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 330,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "回复列表"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display: params.row.status == "1" ? "inline-block" : "none"
                  },
                  on: {
                    click: () => {
                      this.review(params.row.id, 0);
                    }
                  }
                },
                "上架"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display: params.row.status == "0" ? "inline-block" : "none"
                  },
                  on: {
                    click: () => {
                      this.review(params.row.id, 1);
                    }
                  }
                },
                "下架"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: []
    };
  },
  components: {},
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function () {
      var self = this;
      this.comment_id = 0;
      var params = { page: this.pages.current, size: this.pages.size };
      this.$api.headline.commentlist(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          self.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    changePage () {
      this.pages.current = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    review: function (id, index) {
      this.$api.headline.commentstatus({ id: id, status: index }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.renderTable();
        }
      });
    },

    remove: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.headline.commentremove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
    // 查看详情
    detail: function (index) {
      this.modal1 = true;
      this.comment_id = index;
      var params = {
        id: index
      };
      this.$api.headline.replycommentlist(params).then(res => {
        if (res.code == 200) {
          this.datagood = res.result;
        }
      });
      return;
    },
    removereply: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.headline.commentremove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.detail(this.comment_id);
            }
          });
        }
      });
    },
    reviewreply: function (id, index) {
      this.$api.headline.commentstatus({ id: id, status: index }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.detail(this.comment_id);
        }
      });
    },
    // 筛选
    renderTable: function (name) {
      var self = this;
      this.comment_id = 0;
      var ps = {
        page: this.pages.current,
        size: this.pages.size,
        key: this.formItem.key
      };
      this.$api.headline.commentlist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          self.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  }
};
</script>

